import { useMutation, queryCache } from "react-query-legacy";
import { message } from "antd";
import { BillingEngineService } from "services";
import { hoursLoggedQueryKey } from "../constants";

function useQueryDeleteHours() {
  return useMutation(BillingEngineService.deleteWarehouseHours, {
    onSuccess: (response, { type }) => {
      message.success("Deleted row");
      queryCache.refetchQueries([hoursLoggedQueryKey, type]);
    },
  });
}

export default useQueryDeleteHours;
